import { useQuery } from '@tanstack/react-query';
import { getAuditLog, getAuditLogFilters } from '../services/audit-log.service';
import type { AuditLogFilterState, AuditLogPage } from '../types/audit-log.types';

export const useAuditLog = (
  filters: AuditLogFilterState,
  limit = 50,
  cursor?: string,
  enabled = true
) =>
  useQuery<AuditLogPage>({
    queryKey: ['audit-log', filters, limit, cursor],
    queryFn: () =>
      getAuditLog({
        ...filters,
        limit,
        cursor,
      }),
    staleTime: 30_000,
    enabled,
  });

export const useAuditLogFilters = (enabled = true) =>
  useQuery({
    queryKey: ['audit-log', 'filters'],
    queryFn: getAuditLogFilters,
    staleTime: 5 * 60_000,
    enabled,
  });
